import React, { useState, useEffect, useCallback } from 'react'
import { GoogleDriveFolder } from '../types'
import {
  FolderPickerContainer,
  FolderItem,
  FolderIcon,
  FolderLabel,
  EmptyState,
  LoadingSpinner
} from '../style'

interface FolderPickerProps {
  folders: GoogleDriveFolder[]
  selectedFolderId?: string
  isLoading: boolean
  onSelect: (folder: GoogleDriveFolder) => void
  onNavigate?: (folderId: string) => void
}

const FolderSvg = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
  </svg>
)

export const FolderPicker: React.FC<FolderPickerProps> = ({
  folders,
  selectedFolderId,
  isLoading,
  onSelect,
  onNavigate
}) => {
  if (isLoading) {
    return (
      <FolderPickerContainer style={{ alignItems: 'center', justifyContent: 'center', padding: '48px' }}>
        <LoadingSpinner />
      </FolderPickerContainer>
    )
  }

  if (folders.length === 0) {
    return (
      <FolderPickerContainer>
        <EmptyState>No folders found in your Google Drive</EmptyState>
      </FolderPickerContainer>
    )
  }

  return (
    <FolderPickerContainer>
      {folders.map(folder => (
        <FolderItem
          key={folder.id}
          selected={folder.id === selectedFolderId}
          onClick={() => onSelect(folder)}
          onDoubleClick={() => onNavigate?.(folder.id)}
        >
          <FolderIcon>
            <FolderSvg />
          </FolderIcon>
          <FolderLabel>{folder.name}</FolderLabel>
        </FolderItem>
      ))}
    </FolderPickerContainer>
  )
}
